import React, { PureComponent } from 'react';
import { withRouter, Link } from 'react-router-dom';
import MarkdownIt from 'markdown-it';
import { connect } from 'react-redux';
import { getPost } from '../../api/cgi/knowledge';
import _ from 'lodash';
import { parse } from 'query-string';
import { CONTENT_TYPE, COMPONENT_TEMPLATE } from '@/constants/knowledge';
import { reportUserBehaviorCgi } from '@/api/cgi/common';
import { REGEXP } from '@/constants/regexp';
import { authEdu } from '@/pages/utils.js';
import { getWatermarkUrl } from '@/components/watermark';
import qs from 'qs';

function createHtml(data) {
  return { __html: data };
}

function insertHtml(data) {
  return (
    <div
      className={'editor-preview-side'}
      dangerouslySetInnerHTML={createHtml(data)}
    ></div>
  );
}

function escape2Html(str) {
  const arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, (all, t) => arrEntities[t]);
}


function AttachmentDownload(props) {
  const { data = {}, attachment_list = [] } = props;

  const download = (v) => {
    reportUserBehaviorCgi({
      data: {
        behavior: '附件下载',
        page1: '知识',
        page2: `知识库-${props.currentDayTime}`,
        page3: '内容中台文章详情',
        relation_id: data.post_id,
        relation_name: v.attachment_id,
      },
    });
    window.open(v.url);
  };

  return (
    <div className="help_source">
      {attachment_list.length > 0 ? (
        <React.Fragment>
          <div className="help_source_title">资料下载</div>
          {attachment_list.map((v) => {
            return (
              <div key={v.name} className="help_source_detail">
                <div>
                  <span>{v.name}</span>
                </div>
                <div>
                  <i />
                  <a onClick={() => download(v)}>查看</a>
                </div>
              </div>
            );
          })}
        </React.Fragment>
      ) : null}
    </div>
  );
}

/**
 * 文章详情页
 * @query: {
 *    source: 打开来源，用于行为上报。可选值: '公告中心', '知识库目录', '搜索#{keyword}', '最新推荐'。传参时可使用encodeURIComponent，也可不使用
 * }
 */
class ArticleDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      content: '',
      title: '',
      attachment_list: [],
      warterMark: {},
    };
    this.currentDayTime = Date.now(); // 记录时间是为了将该页面所有的上报进行匹配
    this.goBack = this.goBack.bind(this);
    this.startTime = 0;
  }

  componentDidMount() {
    this.getArticleDetail().then((data) => {
      const param1 = {
        behavior: '打开页面',
        page1: '知识',
        page2: '知识库',
        page3: '文章详情',
        relation_id: data.post_id,
        relation_name: data.title,
      }; // 打开页面
      reportUserBehaviorCgi({ data: param1 });

      // "曝光数量"和"打开页面"上报目的一样，但因为要统计"page3: '内容中台文章详情'"还有其他来源，"打开页面"无法进行区分，所以增加"曝光数量"上报
      const param2 = {
        behavior: '曝光数量V2',
        page1: '知识',
        page2: `知识库-${this.currentDayTime}`,
        page3: '内容中台文章详情',
        relation_id: data.post_id,
        relation_name: data.title,
        relation_type: this.getSource(),
      };
      reportUserBehaviorCgi({ data: param2 });
      if (
        data.content?.indexOf('<video') > -1
        && data.content?.indexOf('</video>') > -1
      ) {
        const param3 = {
          behavior: '有视频',
          page1: '知识',
          page2: `知识库-${this.currentDayTime}`,
          page3: '内容中台文章详情',
          relation_id: data.post_id,
          relation_name: data.title,
        };
        reportUserBehaviorCgi({ data: param3 });
      }
    });
    const that = this;
    $('.help_content_main_content').on('click', 'a', function (e) {
      const { data } = that.state;
      const href = $(this).attr('href');
      const param = {
        behavior: '打开页面',
        page1: '知识',
        page2: '知识库',
        page3: $(this).attr('href'),
        relation_id: data.post_id,
        relation_name: data.title,
      };
      reportUserBehaviorCgi({ data: param });
      window.open(href);
      return false;
    });
    this.startTime = Date.now();

    // 页面关闭时上报
    document.body.onbeforeunload = (e) => {
      this.reportTime(true);
    };
  }

  // 获取页面打开来源，用于上报
  getSource = () => {
    return qs.parse(location.href.split('?')[1] || '').source || '-';
  }

  componentWillUnmount() {
    $('.help_content_main_content').off('click', 'a');
    let videoTime = '';
    for (let i = 0; i < $('video').length; i++) {
      videoTime = videoTime ? `${videoTime},${$('video')[i].currentTime}` : $('video')[i].currentTime;
    }
    const { location } = this.props;
    const { id } = parse(location.search);
    const { title } = this.state;
    this.reportTime();
    if ($('video').length >= 1) {
      const param = {
        behavior: '视频播放时长',
        page1: '知识',
        page2: `知识库-${this.currentDayTime}`,
        page3: '内容中台文章详情',
        relation_id: id,
        relation_name: title,
        relation_type: videoTime,
      };
      reportUserBehaviorCgi({ data: param });
    }
  }

  reportTime = (useSendBeacon = false) => {
    const { location } = this.props;
    const { id } = parse(location.search);
    const { title } = this.state;
    const time = Date.now() - this.startTime;
    const param = {
      behavior: '停留时长',
      page1: '知识',
      page2: `知识库-${this.currentDayTime}`,
      page3: '内容中台文章详情',
      relation_id: id,
      relation_name: title,
      relation_type: Math.floor(time / 1000), // relation_type 即将废弃
      val: Math.floor(time / 1000),
    };
    reportUserBehaviorCgi({ data: param }, { useSendBeacon });
  };

  reportUserBehavior = (data) => {
    reportUserBehaviorCgi({ data });
  };

  getArticleDetail() {
    const {
      accountInfo: { knowledge_token, company_id, user_id } = {},
      location = {},
    } = this.props;
    const { id } = parse(location.search);
    return getPost({ data: { knowledge_token, post_id: id } }).then((res) => {
      const { ret, data = {} } = res;
      if (ret === 0) {
        const {
          content,
          post_id,
          title,
          attachment_list,
          has_training,
          watermark: warterMark,
        } = data;

        if (has_training) {
          authEdu({ company_id, user_id });
        }
        this.setState({
          data,
          content,
          title,
          attachment_list,
          warterMark,
        });
        return data;
      }
      return {};
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  renderContent(value, content_type = CONTENT_TYPE.richText) {
    const content = value.replace(
      REGEXP.addObjectHeightRegex,
      '$1height="600px"$3',
    );
    switch (content_type) {
      case CONTENT_TYPE.richText:
        return content;
        break;
      case CONTENT_TYPE.markdown:
        return new MarkdownIt({ html: true }).render(content);
        break;
      case CONTENT_TYPE.componentTemplate: {
        const componentTemplate = JSON.parse(content || '{}').content || [];
        const textCount =          _.filter(
          componentTemplate,
          (v) => [
            COMPONENT_TEMPLATE.richText,
            COMPONENT_TEMPLATE.markdown,
          ].indexOf(v.type) > -1,
        ).length || 0;
        const html = componentTemplate
          .map((v) => {
            const textLabel = textCount > 1 ? `<div class="label">${v.label}</div>` : '';
            switch (v.type) {
              case COMPONENT_TEMPLATE.coverResource:
                if (v.advertiser_name) {
                  return `<img class="cover-resource" src="${v.cover_image_url}" alt="封面图">`;
                }
                break;
              case COMPONENT_TEMPLATE.richText:
                return `${textLabel}${v.content}`;
                break;
              case COMPONENT_TEMPLATE.markdown:
                return `${textLabel}${new MarkdownIt({ html: true }).render(v.content)}`;
                break;
              default:
                break;
            }
            return '';
          })
          .join('');
        return `<div class="component-template">${html}</div>`;
        break;
      }
      default:
        break;
    }
    return '暂不支持该文章类型';
  }

  render() {
    const {
      data = {},
      content = '',
      title = '',
      attachment_list = [],
      warterMark = {},
    } = this.state;
    const warterMarkSrc = getWatermarkUrl(_.values(warterMark).join(' '));
    const markContent = escape2Html(this.renderContent(content, data.content_type));
    return (
      <div
        className="help_detail_container"
        style={{
          backgroundImage: `url(${warterMarkSrc})`,
          backgroundRepeat: 'round',
        }}
      >
        <div className="help_content_main">
          <div className="crumbs help_content_main_title">
            <span
              onClick={this.goBack}
              className="front"
              style={{ cursor: 'pointer' }}
            >
              列表
            </span>
            <i className="spaui-icon icon-crumb-arr"></i>
            {title}
          </div>
          <div className="help_content_main_content">
            {insertHtml(markContent)}
          </div>
          <AttachmentDownload currentDayTime={this.currentDayTime} data={data} attachment_list={attachment_list} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    accountInfo: state.knowledge.knowledge_info,
  };
}

export default withRouter(connect(mapStateToProps)(ArticleDetail));
